<template>
    <div
        v-if="items.length > 0"
        class="bo-product-specs"
    >
        <!-- mobile: the row scrolls sideways, and tapping it (or the chevron) opens the full list -->
        <div
            ref="row"
            class="specs-row"
            :class="{ 'fade-left': fadeLeft, 'fade-right': fadeRight }"
            :role="isMobile ? 'button' : null"
            @click="openPanel"
            @scroll.passive="updateFade"
        >
            <div
                v-for="item in items"
                :key="item.key"
                class="spec-item"
            >
                <div class="spec-label">{{ item.label }}</div>
                <div class="spec-value">{{ item.value }}</div>
            </div>
        </div>
        <button
            v-if="isMobile"
            type="button"
            class="specs-more"
            :aria-label="title"
            @click="openPanel"
        >
            <i class="icon-chevronright"></i>
        </button>

        <div
            v-if="panelOpen"
            class="specs-panel"
        >
            <div class="specs-panel-header">
                <button
                    type="button"
                    class="specs-panel-back"
                    @click="closePanel"
                >
                    <i class="icon-chevronleft"></i>
                </button>
                <span class="specs-panel-title">{{ title }}</span>
                <button
                    type="button"
                    class="specs-panel-close"
                    @click="closePanel"
                >
                    <i class="icon-close"></i>
                </button>
            </div>
            <div class="specs-panel-body">
                <div
                    v-for="item in items"
                    :key="item.key"
                    class="specs-panel-row"
                >
                    <span class="spec-label">{{ item.label }}</span>
                    <span class="spec-value">{{ item.value }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// same breakpoint as $breakpoint-tablet-vertical
const MOBILE_QUERY = "(max-width: 768px)";

export default {
    props: {
        // from productSpecItems (js/frontend/utils/product-specs.js)
        items: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: "Specification",
        },
    },
    data() {
        return {
            isMobile: false,
            panelOpen: false,
            mediaQuery: null,
            // edge fades hint that the mobile row scrolls; each side shows only while there is more to see
            fadeLeft: false,
            fadeRight: false,
        };
    },
    mounted() {
        if (typeof window !== "undefined" && typeof window.matchMedia === "function") {
            this.mediaQuery = window.matchMedia(MOBILE_QUERY);
            this.isMobile = this.mediaQuery.matches;
            this.mediaQuery.addEventListener?.("change", this.onMediaChange);
        }
        window.addEventListener("resize", this.updateFade);
        this.$nextTick(this.updateFade);
    },
    beforeDestroy() {
        this.mediaQuery?.removeEventListener?.("change", this.onMediaChange);
        window.removeEventListener("resize", this.updateFade);
    },
    watch: {
        items() {
            this.$nextTick(this.updateFade);
        },
    },
    methods: {
        onMediaChange(event) {
            this.isMobile = event.matches;
            if (!this.isMobile) {
                this.panelOpen = false;
            }
            this.$nextTick(this.updateFade);
        },
        updateFade() {
            const row = this.$refs.row;
            if (!row || !this.isMobile) {
                this.fadeLeft = false;
                this.fadeRight = false;
                return;
            }
            this.fadeLeft = row.scrollLeft > 1;
            this.fadeRight = row.scrollLeft + row.clientWidth < row.scrollWidth - 1;
        },
        openPanel() {
            if (this.isMobile) {
                this.panelOpen = true;
            }
        },
        closePanel() {
            this.panelOpen = false;
        },
    },
};
</script>
